import moment from 'moment-timezone';
import { Organization } from '../organization';
import { COAAccount } from '../../../services/accounting/chart-of-accounts.service';
import { BudgetItem } from '../budget-item';

export type CategoryAccountType = 'income'|'expense';

export const CATEGORY_ACCOUNT_TYPE = 'category';
export const CATEGORY_INCOME_ACCOUNT_TYPE: CategoryAccountType = 'income';
export const CATEGORY_EXPENSE_ACCOUNT_TYPE: CategoryAccountType = 'expense';

export class Category implements COAAccount
{
    static readonly INTERNAL_USE_LATE_FEE = 1;
    static readonly INTERNAL_USE_APPLICATION_FEE = 2;
    static readonly INTERNAL_USE_PREPAYMENTS = 3;
    static readonly INTERNAL_USE_ACCOUNT_CREDIT_CONTRA = 4;
    static readonly INTERNAL_USE_BAD_DEBT = 5;
    static readonly INTERNAL_USE_DISCOUNTS_CONTRA = 6;
    static readonly INTERNAL_USE_PLATFORM_FEES = 7;

    // Max characters before name truncation in budget table columns
    static readonly CATEGORY_NAME_MAX_CHARS = 24;

    id: number;
    parentId: number;
    parentName: string;
    organizationId: number;
    name: string;
    type: 'income' | 'expense';
    createdAt: string;
    updatedAt: string;
    deletedAt: string;
    sortOrder: number;
    internalUse: number;
    startingBalance: number;
    startingBalanceDate: string;

    organization: Organization;

    children: Category[];
    budgetItems: BudgetItem[] = [];
    old?: Category = null;

    // Whether the name will be truncated in budget table display
    isNameTruncated: boolean = false;

    readonly accountType = CATEGORY_ACCOUNT_TYPE;

    constructor(category: any) {
        this.id = category.id || null;
        this.parentId = category.parentId || null;
        this.parentName = category.parentName || null;
        this.organizationId = category.organizationId || null;
        this.name = category.name || null;
        this.isNameTruncated = this.name?.length > Category.CATEGORY_NAME_MAX_CHARS;
        this.type = category.type || null;
        this.sortOrder = category.sortOrder || 0;
        this.internalUse = category.internalUse || false;
        this.internalUse = category.internalUse || 0;

        this.createdAt = category.createdAt;
        this.updatedAt = category.updatedAt;
        this.deletedAt = category.deletedAt;
        this.startingBalanceDate = category.startingBalanceDate;

        this.startingBalance = category.startingBalance || 0;

        this.organization = category.organization ? new Organization(category.organization) : null;

        if (category.children) {
            this.children = category.children.map(cat => {
                cat.parentName = this.name;
                return new Category(cat);
            });
        } else {
            this.children = [];
        }

        if (category.budgetItems) {
            this.budgetItems = category.budgetItems.map(item => {
                return new BudgetItem(item);
            });
        }
    }

    get label() {
        return this.name;
    }
}
